import type { IEventEmitter, TEventData, TEventEmitterListener, TEventName } from '../IEventEmitter';

export class EventEmitter implements IEventEmitter {
  #listeners = new Map<TEventName, Set<TEventEmitterListener<any>>>();

  public subscribe<E extends TEventName>(event: E, listener: TEventEmitterListener<E>): () => void {
    const listeners = this.#listeners.get(event) ?? new Set<TEventEmitterListener<E>>();

    listeners.add(listener);
    this.#listeners.set(event, listeners);

    return () => this.unsubscribe(event, listener);
  }

  public unsubscribe<E extends TEventName>(event: E, listener: TEventEmitterListener<E>): void {
    this.#listeners.get(event)?.delete(listener);
  }

  public destroy(): void {
    this.#listeners.clear();
  }

  public emit(data: TEventData): void {
    const listeners = this.#listeners.get(data.event);

    if (!listeners) {
      return;
    }

    // Копируем набор, чтобы отписка слушателя внутри обработчика не ломала текущую итерацию.
    [...listeners].forEach(listener => listener(data));
  }
}
